export const NEED_SEARCH_PATHS = {
	appointment: '/paris?capacity=2-2,3-3,4-4',
	team: '/paris?capacity=6-6,8-8,10-10',
	seminar: '/paris?capacity=10-10,12-12,14-14,16-',
} as const
